import { Button, styled } from '@mui/material';

export const FormWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  padding: 30px;
`;

export const ButtonsWrapper = styled('div')`
  display: block;
  text-align: center;
`;

export const SaveButton = styled(Button)`
  background: #4a89dc;
  color: #fff;
`;

export const CancelButton = styled(Button)`
  background: #9e9e9e33;
  color: #000;
  margin-left: 15px;
`;

export const TitleLabel = styled('h3')`
  text-align: center;
  padding: 0;
  color: #333;
  margin: 0;
  font-size: 2.5rem;
  font-weight: 400;
  line-height: 40px;
`;

export const FormError = styled('p')`
  color: #d32f2f;
  font-weight: 400;
  font-size: 0.75rem;
  margin-top: 3px;
`;
